import Box from 'assets/components/box/Box';
import Button from 'assets/components/button/Button';
import ThemeButtonCircle from 'assets/components/button/themes/Theme.Button.Circle';
import DataMap from 'assets/components/dataMap/DataMap';
import Icon from 'assets/components/icon/Icon';
import Page from 'assets/components/page/Page';
import ThemePageError from 'assets/components/page/themes/Theme.Page.Error';
import ThemeTableSimple from 'assets/components/table/themes/Theme.Table.Simple';
import { getLocales } from 'assets/locales/Locale';
import ThemeWrapperStack from 'assets/themes/wrappers/Theme.Wrapper.Stack';
import { combineStrings } from 'assets/utils/data/String';
import { orderBy } from 'lodash';
import { VehicleClassAction, useVehicleClassProvider } from '../VehicleClass.Hooks';

export default function VehicleClassList() {
  const { lang } = getLocales();
  const { listApi, pageRouter, permissions } = useVehicleClassProvider();

  return !listApi.payload && !listApi.isExecuting && listApi.apiCounter > 0 ? (
    <Page
      class={ThemePageError}
      sidebar={<Icon class="fas-clipboard-list" />}
      header={lang.classes}
      render={lang.noInfo}
    />
  ) : (
    <table className={ThemeTableSimple}>
      <thead>
        <tr>
          <th>{lang.classCode}</th>
          <th>{lang.description}</th>
          <th>{lang.models}</th>
          <th data-actions>{lang.actions}</th>
        </tr>
      </thead>
      <tbody>
        <DataMap
          data={listApi.payload?.data}
          render={({ data: vehicleClass }) => (
            <tr key={vehicleClass.id}>
              <td>
                <b>{vehicleClass.code}</b>
              </td>
              <td>{vehicleClass.description}</td>
              <td>
                {orderBy(vehicleClass.vehicleModels, ['vehicleMake.makeCode', 'name'], ['asc', 'asc'])
                  .map((it) => combineStrings(' ', it.vehicleMake?.makeCode, it.name))
                  .join(', ')}
              </td>
              <td>
                <Box class={ThemeWrapperStack}>
                  <Button
                    onClick={pageRouter.updateParams}
                    data={{
                      id: vehicleClass.id.toString(),
                      action: VehicleClassAction.EDIT,
                    }}
                    disabled={!permissions.EDIT_VEHICLECLASS}
                    class={ThemeButtonCircle}
                    media={<Icon class="fas-edit" />}
                    htmlElementProps={{ title: lang.edit }}
                    active
                  />
                  <Button
                    onClick={pageRouter.updateParams}
                    data={{
                      id: vehicleClass.id.toString(),
                      action: VehicleClassAction.DELETE,
                    }}
                    disabled={!permissions.DELETE_VEHICLECLASS}
                    class={ThemeButtonCircle}
                    media={<Icon class="fas-trash" />}
                    htmlElementProps={{ title: lang.delete }}
                    active
                  />
                  <Button
                    onClick={pageRouter.updateParams}
                    data={{
                      id: vehicleClass.id.toString(),
                      action: VehicleClassAction.COPY,
                    }}
                    disabled={!permissions.EDIT_VEHICLECLASS}
                    class={ThemeButtonCircle}
                    media={<Icon class="fas-copy" />}
                    htmlElementProps={{ title: lang.copy }}
                    active
                  />
                </Box>
              </td>
            </tr>
          )}
        />
      </tbody>
    </table>
  );
}
